import React from 'react';
import { useNavigate } from "react-router-dom";
import URL from "../../../../constants/url";
import style from './MembershipFailed.module.css';
import imgComplete from '../../../../images/common/i_signup_fail.svg';


const MembershipFailed = () => {

    const navigate = useNavigate();

    return (
        <>

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">

                    <div className={style['mid-box']}>
                        <div className='animation-2'>
                            <p className={style['top']}>
                                <b>환자정보</b>가 <br />
                                <b>등록</b>되지 않았습니다
                            </p>
                            <div className={style['mid']}>
                                <object data={imgComplete} alt="" aria-hidden='true' />
                            </div>
                            <div className={style['botm']}>
                                <span>원활한 서비스 이용을 위해 <br />
                                <b>관리자에게 </b> 문의하세요.</span>
                            </div>
                        </div>
                    </div>


                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">

                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                        onClick={() => navigate(URL.IDENTITY)}>
                                    <span>다시 연동하기</span>
                                </button>

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>

        </>
    )
}

export default MembershipFailed;
